import React, { useMemo } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import BadgeCard from '../components/attendence/BadgeCard'
import LockedBadges from '../components/badges/LockedBadges'

// Hooks
import { useChildren, useApi } from '../hooks';

// Services
import { badgesService, enrollmentsService } from '../api/services';

const Badges = () => {
  // Get selected child from context
  const { selectedChild } = useChildren();

  // Get first active enrollment for the selected child
  const { data: enrollmentsData, error: enrollmentsError } = useApi(
    () => enrollmentsService.getMy({
      child_id: selectedChild?.id,
      status: 'active',
    }),
    {
      initialData: [],
      dependencies: [selectedChild?.id],
      autoFetch: !!selectedChild?.id,
      onError: (err) => console.error('Failed to load enrollments:', err),
    }
  );

  const firstEnrollment = useMemo(() => {
    if (!enrollmentsData || enrollmentsData.length === 0) return null;
    return enrollmentsData.find(e => e.child_id === selectedChild?.id) || enrollmentsData[0];
  }, [enrollmentsData, selectedChild?.id]);

  // The child's badges for the enrollment: earned, and still locked
  const { data: badgeStatus, loading: loadingBadges, error: badgesError } = useApi(
    () => badgesService.getStatusByEnrollment(firstEnrollment?.id),
    {
      initialData: { earned: [], locked: [] },
      dependencies: [firstEnrollment?.id],
      autoFetch: !!firstEnrollment?.id,
      onError: (err) => console.error('Failed to load badges:', err),
    }
  );

  // Combined error state
  const hasError = enrollmentsError || badgesError;

  // Transform API badges to component format - child-based from API
  const badges = useMemo(() => {
    return (badgeStatus?.earned || []).map((badge, index) => ({
      title: badge.name || badge.title,
      subtitle: badge.earned_at
        ? `Achieved: ${new Date(badge.earned_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
        : badge.description,
      icon: badge.icon_url || badge.image_url,
      active: index === 0,
    }));
  }, [badgeStatus]);

  return (
    // <div className=" min-h-screen max-sm:h-fit bg-gradient-to-b from-[#f3f6fb] via-[#dee5f2] to-[#c7d3e7] opacity-8 max-sm:pb-20">
    <div className=" min-h-screen flex flex-col justify-between max-sm:h-fit bg-page-gradient opacity-8 max-sm:pb-20">

      <Header />
 <main className=" mx-6 py-8 max-sm:py-2 max-sm:mx-3">
      <h1 className="text-fluid-xl font-manrope font-medium text-[#173151] mb-4">
        Achievements
      </h1>

      {/* Error Alert */}
      {hasError && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 font-manrope">
          <p className="font-medium">Unable to load badges</p>
          <p className="text-sm mt-1">Please try refreshing the page or check back later.</p>
        </div>
      )}

<div className="flex flex-wrap gap-4 max-sm:justify-center max-sm:px-2 py-2 mb-8">
        {loadingBadges ? (
          // Loading skeleton
          Array(6).fill(0).map((_, i) => (
            <div key={i} className="w-[200px] h-[200px] max-sm:w-full bg-gray-200 rounded-2xl animate-pulse" />
          ))
        ) : badges.length > 0 ? (
          badges.map((badge, i) => (
            <BadgeCard key={i} {...badge} compact={false} />
          ))
        ) : (
          <div className="w-full text-center py-8 text-gray-500">
            No badges earned yet. Keep up the good work!
          </div>
        )}
      </div>

      {!loadingBadges && <LockedBadges badges={badgeStatus?.locked || []} />}
    

      </main>
      <Footer isFixed={false} mobileHidden={true} />
</div>
  )
}

export default Badges